import classNames from 'classnames'
import React from 'react'

export interface LogoProps {
    width: number
    className?: string
}

export const FlexLogo = (props: LogoProps) => {
    const className = classNames('flex-logo', props.className)

    return (
        <svg width={props.width} className={className} viewBox="0 0 99.95 96.22" xmlns="http://www.w3.org/2000/svg">
            <path
                className="flex-logo__filled"
                d="m48.17 73.36c-13.51 0-24.51-10.99-24.51-24.51s10.99-24.5 24.51-24.5c6.55 0 12.7 2.55 17.33 7.18l-1.32 1.32c-4.28-4.28-9.96-6.63-16.01-6.63-12.48 0-22.64 10.16-22.64 22.64s10.15 22.64 22.64 22.64 22.64-10.16 22.64-22.64v-4.02h1.87v4.02c0 13.51-10.99 24.51-24.51 24.51z"
            />
            <path
                className="flex-logo__filled"
                d="m48.17 68.91c-11.06 0-20.05-9-20.05-20.05s9-20.05 20.05-20.05c5.36 0 10.39 2.08 14.18 5.87l-1.32 1.32c-3.43-3.43-8-5.33-12.86-5.33-10.03 0-18.18 8.16-18.18 18.18s8.16 18.18 18.18 18.18 18.18-8.16 18.18-18.18v-8.48h1.87v8.48c0 11.06-9 20.05-20.05 20.05z"
            />
            <path
                className="flex-logo__filled"
                d="m48.17 64.45c-8.6 0-15.6-7-15.6-15.6s7-15.6 15.6-15.6c4.17 0 8.08 1.62 11.03 4.57l-1.32 1.32c-2.59-2.59-6.04-4.02-9.71-4.02-7.57 0-13.73 6.16-13.73 13.73s6.16 13.73 13.73 13.73 13.73-6.16 13.73-13.73v-4.02h1.87v4.02c0 8.6-7 15.6-15.6 15.6z"
            />
            <polygon
                className="flex-logo__filled"
                points="74.35 48.77 67.29 41.7 60.22 48.77 58.9 47.45 67.29 39.06 75.68 47.45"
            />
            <rect className="flex-logo__empty" width="99.95" height="96.22" />
        </svg>
    )
}
